import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: theme.colorPalette.green_90,
    padding: theme.spacing(6, 0, 6, 0),
    borderTop: `2px solid ${theme.colorPalette.green_80}`
  },
  button: {
    display: 'flex',
    height: 36,
    width: 875,
    padding: '4px 16px',
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttonLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

export default makeStyles(styles);
